<template>
  <div>
    <div class="row propertiesRow no-row-padding">
      <slot>
        <template v-if="controls">
          <div class="col-10">
            <h3 class="sectionTitle">{{ title }}</h3>
          </div>
          <div class="col-2 d-flex justify-content-end">
            <div class="btn-group" role="group" aria-label="Basic example">
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="selectNone(toggles)"
              >
                {{ $t("common.actions.none") }}
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm"
                @click="selectAll(toggles)"
              >
                {{ $t("common.actions.all") }}
              </button>
            </div>
          </div>
        </template>
      </slot>
    </div>
    <div class="row propertiesContainer">
      <div class="col-12">
        <div class="row">
          <div
            class="col-xl-4 col-md-6 col-sm-12"
            v-for="(toggle, i) in toggles"
            :key="i"
          >
            <Toggle
              :title="computeToggleTitle(toggle)"
              v-model="toggle.value"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toggle from "@/components/common/Toggle";

export default {
  name: "ToggleGroup",
  components: {
    Toggle,
  },
  props: {
    toggles: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
    title: {
      type: String,
      required: false,
      default: "MISSING PROP `title`",
    },
    controls: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    computeToggleTitle: function (toggle) {
      if (
        toggle.localizedName &&
        this.$options.filters.localized(toggle.localizedName)
      ) {
        return this.$options.filters.localized(toggle.localizedName);
      }
      if (toggle.key === undefined) {
        return toggle.name;
      }

      // Check if we have a translation for the toggle
      let translation = this.$i18n.t("properties." + toggle.key);

      return translation ? translation : toggle.name;
    },
    selectNone: function (lst) {
      // lst.map(el => el.value = false);
      this.toggles.map((el) => (el.value = false));
    },
    selectAll: function (lst) {
      this.toggles.map((el) => (el.value = true));
    },
  },
  watch: {
    toggles: {
      deep: true,
      handler: function (newVal, oldVal) {
        this.$emit("update:toggles", newVal);
      },
    },
  },
  mounted() {
    let id = this.$vnode.parent.tag;

    this.$root.$on(`${id}-selectAll`, () => {
      this.selectAll();
    });

    this.$root.$on(`${id}-selectNone`, () => {
      this.selectNone();
    });
  },
};
</script>

<style lang="scss" scoped>
$border-radius: 5px;
.btn {
  border-radius: $border-radius;
}

.propertiesRow {
  margin-bottom: 15px;
}

.sectionTitle {
  margin-top: 12px;
  margin-bottom: 12px;
}

.btn-sm {
  line-height: 1.25em !important;
  max-height: 2.5em !important;
}
</style>
